
import { useStore } from '@/store'
import { defineComponent, inject, reactive, ref } from 'vue'
import FavoriteService from '@/services/form/favorite-service'
import ToastService from '@/services/page/toast.service'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import { FormActionTypes } from '@/store/modules/form/action-types'
import * as UrlConstants from '@/constants/url-constants'
import { ConfigurationModel } from '@/models/configuration-model'
import Analytics from '@/singletons/analytics'
import ConfirmDialog from '@/components/Abstract/ConfirmDialog.vue'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'FavoriteDialog',
  components: {
    ConfirmDialog
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const favorites = reactive(['① ', '② ', '③ ', '④ ', '⑤ ', '⑥ '])
    let visible = ref(false)
    let disableds = ref([] as Array<boolean>)
    let favoriteService = new FavoriteService()
    let toastService = new ToastService()

    emitter.on('openFavoriteDialog', () => {
      visible.value = true
      emitter.emit('showOverlay')
      updateDisableds()
      document.body.classList.add('dialog-open')
    })

    emitter.on('hideDialogs', () => {
      visible.value = false
      document.body.classList.remove('dialog-open')
    })

    const onResetClick = () => {
      emitter.emit('showResetConfirm')
    }

    const onResetYes = () => {
      Analytics.instance.sendResetEvent()
      reset()
      closeDialog()
    }

    function reset() {
      try {
        store.dispatch(ConfigurationActionTypes.SET_CONFIGURATION, new ConfigurationModel())
        store.dispatch(FormActionTypes.SET_CURRENT_TAB, 0)
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has(UrlConstants.body)) {
          window.location.href = window.location.href.split('?')[0]
        }
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    const onShowGuideClick = () => {
      emitter.emit('showInstruction')
      closeDialog()
      Analytics.instance.sendShowInstructionEvent()
    }

    const onSaveClick = (index: number) => {
      try {
        favoriteService.save(store.getters.currentConfig, index)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }

      toastService.showSuccess('番に保存した')
      closeDialog()
      Analytics.instance.sendSaveFavoriteEvent(index)
    }

    const onLoadClick = (index: number) => {
      try {
        const config = favoriteService.load(index)
        store.dispatch(ConfigurationActionTypes.SET_CONFIGURATION, config)
        store.dispatch(FormActionTypes.SET_CURRENT_TAB, 0)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }

      toastService.showSuccess('番を呼び出した')
      Analytics.instance.sendLoadFavoriteEvent(index)
    }

    const hideDialog = (_) => {
      closeDialog()
    }

    function updateDisableds() {
      disableds.value = favoriteService.determineDisableds(favorites.length)
    }

    function closeDialog() {
      visible.value = false
      emitter.emit('hideOverlay')
      document.body.classList.remove('dialog-open')
    }

    return {
      favorites,
      disableds,
      visible,
      hideDialog,
      onResetClick,
      onShowGuideClick,
      onSaveClick,
      onLoadClick,
      onResetYes
    }
  }
})
